import { Get } from '../http/httpVerbs';

export const apiGetAprenda = async (comunidadeId) => {
    try {
        let url = `${process.env.REACT_APP_API_URL}/aprenda`;
        if (comunidadeId) {
            url += `?comunidade=${comunidadeId}`;
        }
        const response = await Get(url);
        return response;
    } catch (error) {
        throw error;
    }
};
